/**
 * _navigation.js
 * simple class toggling for site navgation.
 */

import "classlist-polyfill";

const BUTTON_ID = "#menu-toggle";
const NAV_OPEN = "show-nav";

function toggle_nav() {
    document.documentElement.classList.toggle("show-nav");
}

(function init_nav() {
    let nav_button = document.querySelector(BUTTON_ID);

    if(nav_button === null)
        return;

    nav_button.addEventListener("click", toggle_nav);
})();
